import { t } from 'i18n';
import { IMap } from 'interfaces';

export type IType = IMap<{ value: number; label: string }>;

const STATUS_ASSIGNMENT_STATUS: IType = {
  UNASSIGNED: {
    value: 3,
    label: t('Unassigned'),
  },
  ASSIGNED: {
    value: 2,
    label: t('Assigned'),
  },
  ALL: {
    value: 1,
    label: t('All'),
  },
};

const DEFAULT_TASK_IN_PROGRESS_PARAMS = {
  page: 1,
  pageSize: 10,
  assignedStaff: STATUS_ASSIGNMENT_STATUS.UNASSIGNED.value,
};

const ROLE_SALE_OR_LEADER = {
  ALL: 0,
  SALE: 1,
  LEADER: 2,
};

export default {
  STATUS_ASSIGNMENT_STATUS,
  DEFAULT_TASK_IN_PROGRESS_PARAMS,
  ROLE_SALE_OR_LEADER,
};
